import React, { useState } from 'react';
import styled from 'styled-components';
import { BeginnersGuideModal } from '../BeginnersGuide/BeginnersGuide';
import {scrollToTop} from '../ScrollToTop';

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 8rem; /* 140px */
  height: 2rem; /* 44px */
  background: #6d02a2;
  border-radius: 0.5rem; /* 8px */
  padding: 0.5rem 0.75rem; /* 8px 12px */
  cursor: pointer;
  transition: background-color 0.2s;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell;
  user-select: none;
  color: #fff;
  font-size: 0.875rem; /* 14px */
  font-weight: 600;
  text-align: center;

  &:hover {
    background: #250D9F;
  }

  @media (max-width: 640px) {
    width: 6rem; /* Smaller width for small screens */
    height: 1.75rem; /* 40px */
    padding: 0.375rem 0.625rem; /* 6px 10px */
  }

  @media (max-width: 400px) {
    width: 5rem; /* Even smaller width for very small screens */
    font-size: 0.7rem; /* Smaller font size */
  }

  @media (max-width: 320px) {
    width: 4.5rem; /* Further reduce width */
    height: 2.25rem; /* Adjust height */
    font-size: 0.65rem; /* Reduce font size */
    padding: 0.25rem 0.5rem; /* Scale down padding */
  }
`;

export const HowToPlayButton: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <ButtonContainer

        onClick={() => {
          handleClick();
          scrollToTop(); // Scroll to the top when the button is clicked
        }}
        role="button">
        BEGINNER&apos;S GUIDE
      </ButtonContainer>
      {isModalOpen && <BeginnersGuideModal onClose={handleCloseModal} />}
    </>
  );
};

export default HowToPlayButton;